import React, { useState, useEffect } from "react";
import { PartyInfoFilterContainer } from "../../../PartyInfo/PartyInfoFilter";
import LineBtn from "../../../../../Button/LineBtn";
import Flex from "../../../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../../../Filters/DropDown";
import ConfirmBtn from "../../../../../Button/ConfirmBtn";
import { atom, useRecoilState } from "recoil";
import {
  getMatchMakingSubsOptionList,
  getN_MatchMakingSubsOptionList,
} from "../../../../../../AdminApi/commFunc";
import MatchMakingPartyInputModal from "./N_MatchMakingPartyInputModal";
import MatchMakingPartyChatModal from "./N_MatchMakingPartyChatModal";
import Search from "../../../../../Filters/Search";

export const matchMakingPartyFilter = atom({
  key: "matchMakingPartyFilter",
  default: {
    subsId: "",
    searchValue: "",
    searchComment: "",
    page: 0,
  },
});

interface MatchMakingPartyFilterProps {
  refetch: () => void;
}

export default function MatchMakingPartyFilter({
  refetch,
}: MatchMakingPartyFilterProps) {
  const subsOptionList = getN_MatchMakingSubsOptionList();

  const [filter, setFilter] = useRecoilState(matchMakingPartyFilter);
  const [searchValue, setSearchValue] = useState<string | undefined>(
    filter?.searchValue !== "" ? filter?.searchValue : ""
  );
  const [subscription, setSubscription] = useState<OptionType>({
    value: filter?.subsId !== "" ? filter?.subsId : "",
    label:
      filter?.subsId !== ""
        ? subsOptionList?.find((s) => s.value === filter?.subsId)?.label
        : "Subscription 선택",
  });
  const [inputModal, setInputModal] = useState(false);
  const [chatModal, setChatModal] = useState(false);

  useEffect(() => {
    if (searchValue && searchValue?.length > 0) {
      setFilter((prev) => ({
        ...prev,
        searchValue: `${searchValue}`,
      }));
    }
  }, [searchValue]);

  return (
    <>
      <PartyInfoFilterContainer maxWidth={800}>
        <LineBtn
          btnText="뉴 매치메이킹 파티 추가"
          btnHeight={38}
          icon="add"
          btnClickEvent={() => setInputModal(true)}
        />

        <LineBtn
          btnText="채팅 수신 이력"
          btnHeight={38}
          icon="chat"
          btnClickEvent={() => setChatModal(true)}
        />
      </PartyInfoFilterContainer>

      <PartyInfoFilterContainer>
        <Search placeholder="PID 입력" setSearchValue={setSearchValue} />

        <Flex gapSize={10}>
          <DropDown
            optionList={subsOptionList}
            dropdownValue={subscription}
            setDropDownValue={setSubscription}
          />

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            isDisabled={subscription.value === ""}
            btnClickEvent={() => {
              setFilter((prev) => ({
                ...prev,
                subsId: subscription?.value ?? "",
              }));
            }}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            disabled={subscription.value === ""}
            btnClickEvent={() => {
              setSubscription({
                value: "",
                label: "Subscription 선택",
              });
              setFilter((prev) => ({
                ...prev,
                subsId: "",
              }));
            }}
          />
        </Flex>
      </PartyInfoFilterContainer>

      {inputModal && (
        <MatchMakingPartyInputModal
          closeEvent={() => setInputModal(false)}
          confirmEvent={() => refetch()}
        />
      )}

      {chatModal && (
        <MatchMakingPartyChatModal closeEvent={() => setChatModal(false)} />
      )}
    </>
  );
}
